export const allowedVideoTypes = [
  'video/mp4', // для .mp4
  'video/mpeg', // для .mpeg
  'video/ogg', // для .ogv
  'video/webm', // для .webm
  'video/quicktime', // для .mov
  'video/x-msvideo', // для .avi
  'video/x-matroska', // для .mkv
];

export const allowedImageTypes = [
  'image/jpeg', // .jpg and .jpeg
  'image/png', // .png
  'image/svg+xml', // .svg
];

export const archiveMimeTypes = [
  'application/zip', // .zip
  'application/x-zip-compressed', // .zip (alternative)
  'application/vnd.rar', // .rar
  'application/x-rar-compressed', // .rar (alternative)
  'application/x-7z-compressed', // .7z
  'application/x-tar', // .tar
  'application/gzip', // .gz
  'application/x-gzip', // .gz (alternative)
];

export const docMimeTypes = [
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.oasis.opendocument.text', // .odt
];

export const xlsMimeTypes = [
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/vnd.oasis.opendocument.spreadsheet', // .ods
];

export const pptMimeTypes = [
  'application/vnd.ms-powerpoint', // .ppt
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
  'application/vnd.oasis.opendocument.presentation', // .odp
];

export const allowedFileTypes = [
  ...allowedVideoTypes,
  ...allowedImageTypes,
  ...archiveMimeTypes,
  ...docMimeTypes,
  ...xlsMimeTypes,
  ...pptMimeTypes,
  'application/pdf',
  'application/rtf',
  'text/plain',
  'text/csv',
  'text/html',
  'application/json',
  'application/xml',
];

// Словарь для преобразования MIME типов в читаемый формат
export const mimeTypeLabels = {
  // Video
  'video/mp4': 'mp4',
  'video/mpeg': 'mpeg',
  'video/ogg': 'ogv',
  'video/webm': 'webm',
  'video/quicktime': 'mov',
  'video/x-msvideo': 'avi',
  'video/x-matroska': 'mkv',

  // Images
  'image/jpeg': 'jpeg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/svg+xml': 'svg',

  // Archives
  'application/zip': 'zip',
  'application/x-zip-compressed': 'zip',
  'application/vnd.rar': 'rar',
  'application/x-rar-compressed': 'rar',
  'application/x-7z-compressed': '7z',
  'application/x-tar': 'tar',
  'application/gzip': 'gz',
  'application/x-gzip': 'gz',

  // Documents - Word
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.oasis.opendocument.text': 'odt',

  // Documents - Excel
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.oasis.opendocument.spreadsheet': 'ods',

  // Documents - PowerPoint
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'application/vnd.oasis.opendocument.presentation': 'odp',

  // Other
  'application/pdf': 'pdf',
  'application/rtf': 'rtf',
  'text/plain': 'txt',
  'text/csv': 'csv',
  'text/html': 'html',
  'application/json': 'json',
  'application/xml': 'xml',
};

/**
 * Преобразует MIME тип в читаемый короткий формат
 * @param {string} mimeType - MIME тип файла
 * @returns {string} Короткое название формата или оригинальный MIME тип
 */
export const getReadableMimeType = (mimeType) => {
  if (!mimeType) return '';

  // Если есть в словаре, возвращаем короткое название
  if (mimeTypeLabels[mimeType]) {
    return mimeTypeLabels[mimeType];
  }

  return mimeType;
};
